import { render } from "./AppIcon.vue?vue&type=template&id=48be7c14&scoped=true"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"

import "./AppIcon.vue?vue&type=style&index=0&id=48be7c14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48be7c14"]])

export default __exports__